"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const o=require("./index71.js");var r=o.wellKnownSymbol,e=r("toStringTag"),t={};t[e]="z";var n=String(t)==="[object z]";exports.toStringTagSupport=n;
